import _ from "lodash";
/**
 * If all curriculum programs are free then organization is considered as free
 */
import ACLStore from "lib/aclStore";
import { PARENT } from "Constants/stringConstants";
import {
  ENABLE_FUTURE_AY_IN_TEACHER_PORTAL_AY_SWITCHER,
  ENABLE_USER_MIDDLE_NAME,
  ADMIN_PORTAL_ACCESS_PERMISSION,
  PROGRAMME_WIDE_CONFIGURATIONS_ACCESS_PERMISSION,
  ENABLE_AI_TUTOR,
  COMBINE_CURRICULUM_HOME_PAGE_PERMISSION,
  STATIC_WIDGETISED_SCHOOL_HOMEPAGE_V0,
  WIDGETISED_SCHOOL_HOMEPAGE,
} from "Constants/permissionConstants";
import { getIsAIEnabledInAnnouncementModule } from "Announcements/modules/aclStoreUtils";
import { getSettingValue } from "modules/PermissionModule";
import { AI_MODULES_FOR_MARKETING } from "ChildrenPage/components/AIModuleMarketingModal/AIModuleMarketingUtils";
import {
  getOrganizationId,
  getUserId,
  getSelectedCurriculumId,
  getUserCurriculumPrograms,
} from "modules/CommonSelectors";
import { CURRICULUM_TYPE_ORDER_MAPPING } from "Constants";
let store;
import("store/createStore").then(importedModule => {
  store = importedModule.store;
});

import {
  HOME_PAGE_FEATURE_ANNOUNCEMENT,
  HOME_PAGE_FEATURE_ATTENDANCE,
  HOME_PAGE_FEATURE_CALENDAR,
  HOME_PAGE_FEATURE_CLASSROOM_TODO,
  HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
  HOME_PAGE_FEATURE_GOALS,
  HOME_PAGE_FEATURE_LEARNER_PORTFOLIO,
  HOME_PAGE_FEATURE_MESSAGING,
  HOME_PAGE_FEATURE_PROGRESS_REPORT,
  HOME_PAGE_FEATURE_SNP,
  HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_DP_SUBJECT_CENTER,
  HOME_PAGE_FEATURE_TODDLE_ANALYTICS,
  HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_MB_LIBRARY,
  HOME_PAGE_FEATURE_MB_CONTENT_SKILLS,
  HOME_PAGE_FEATURE_MB_PUBLISH_UNIT,
  HOME_PAGE_FEATURE_HOMEROOM,
  HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
} from "Courses/components/TeacherCourses/Constants";
import {
  getDefaultAccountManagerDetailsFromCache,
  getOrganizationDetailsFromCache,
  getPlatformUserCurriculumProgramsFromCache,
} from "./PlatformGraphqlHelpers";
import ACLStorage from "lib/aclService";
import { getOrganizationGlobalConstantsFromCache } from "modules/CommonGraphqlHelpers";
import { getGlobalTimezone, getTimezoneByValue } from "Utils";
import { getProgramListForModule } from "Platform/routes/HomePage/modules/HomePageUtils";

export const getOrganizationFreeStatus = ({ curriculumPrograms }) => {
  return _.every(curriculumPrograms, curriculumProgram => {
    return _.get(curriculumProgram, "subscriptionPlan.isFree", false);
  });
};

export const getPaidCurriculumPrograms = ({ curriculumPrograms }) => {
  return _.filter(
    curriculumPrograms,
    ({ subscriptionPlan = {} }) => !_.get(subscriptionPlan, "isFree", false)
  );
};

export const getPaidCurriculumProgramIds = ({ curriculumPrograms }) => {
  const paidCurriculumPrograms = getPaidCurriculumPrograms({
    curriculumPrograms,
  });

  return _.map(paidCurriculumPrograms, ({ id }) => id);
};

export const getCurriculumProgramAcronymById = ({ curriculumPrograms }) => {
  return _.reduce(
    curriculumPrograms,
    (result, { id, acronym }) => {
      return { ...result, [id]: acronym };
    },
    {}
  );
};

export const getCurriculumProgramAcronym = curriculumProgram => {
  return _.get(curriculumProgram, "acronym");
};

export const getCurriculumProgramLabel = ({
  curriculumProgramId,
  shouldIncludeAcronym = false,
  curriculumPrograms,
  curriculumProgram,
}) => {
  if (!_.isEmpty(curriculumProgram)) {
    const { label, acronym } = curriculumProgram;

    return shouldIncludeAcronym ? `${label} (${acronym})` : label;
  }

  const currentCurriculumProgram = _.find(
    curriculumPrograms,
    ({ id }) => id == curriculumProgramId
  );

  const { label, acronym } = currentCurriculumProgram;

  return shouldIncludeAcronym ? `${label} (${acronym})` : label;
};

export const getFutureAcademicYearPlanningAllowedStatus = ({
  futureAcademicYear,
  isAdminPage,
  isAccountOrSchoolPortal,
}) => {
  const futureAcademicYearReviewStatus = _.get(
    futureAcademicYear,
    "transitionReviewStatus",
    "NOT_STARTED"
  );

  if (isAdminPage || isAccountOrSchoolPortal) {
    return !_.isEqual(futureAcademicYearReviewStatus, "NOT_STARTED");
  }

  return (
    ACLStore.can(ENABLE_FUTURE_AY_IN_TEACHER_PORTAL_AY_SWITCHER) &&
    !_.isEqual(futureAcademicYearReviewStatus, "NOT_STARTED")
  );
};

export const getUbdAssessmentTypes = assessmentTypes => {
  return _.reduce(
    assessmentTypes,
    (result, { id, uid, label, metadata = {} }) => {
      return {
        ...result,
        [uid]: {
          id,
          label,
          ...metadata,
          isEnabled: true,
        },
      };
    },
    {}
  );
};

export const isUserMiddleNameEnabled = () => {
  return ACLStore.can(ENABLE_USER_MIDDLE_NAME);
};

export const GLOBAL_HEADER_SHORTCUTS_MAPPING = {
  [HOME_PAGE_FEATURE_ANNOUNCEMENT]: {
    code: "Semicolon",
    shortcutKey: `;`,
  },
  [HOME_PAGE_FEATURE_ATTENDANCE]: {
    code: "KeyT",
    shortcutKey: "T",
  },
  [HOME_PAGE_FEATURE_CLASSROOM_TODO]: {
    code: "KeyA",
    shortcutKey: `A`,
  },
  [HOME_PAGE_FEATURE_CALENDAR]: {
    code: "KeyO",
    shortcutKey: "O",
  },
  [HOME_PAGE_FEATURE_FAMILY_COMMUNICATION]: {},
  [HOME_PAGE_FEATURE_MESSAGING]: {
    code: "KeyM",
    shortcutKey: `M`,
  },
  [HOME_PAGE_FEATURE_PROGRESS_REPORT]: {
    code: "KeyR",
    shortcutKey: "R",
  },
  [HOME_PAGE_FEATURE_SNP]: {
    code: "KeyE",
    shortcutKey: `E`,
  },
  [HOME_PAGE_FEATURE_LEARNER_PORTFOLIO]: {},
  [HOME_PAGE_FEATURE_EDUCATOR_CENTER]: {},
  [HOME_PAGE_FEATURE_GOALS]: {},
  [HOME_PAGE_FEATURE_MB_LIBRARY]: {},
  [HOME_PAGE_FEATURE_HOMEROOM]: {},
  [HOME_PAGE_FEATURE_DP_SUBJECT_CENTER]: {},
  [HOME_PAGE_FEATURE_TODDLE_ANALYTICS]: {
    code: "KeyI",
    shortcutKey: `I`,
  },
  [HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT]: {
    code: "KeyB",
    shortcutKey: "B",
  },
  [HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER]: {},
  [HOME_PAGE_FEATURE_SCHOOL_LIBRARY]: {
    code: "KeyS",
    shortcutKey: "S",
  },
  [HOME_PAGE_FEATURE_MB_CONTENT_SKILLS]: {},
  [HOME_PAGE_FEATURE_MB_PUBLISH_UNIT]: {},
  COURSE_1: {
    code: "Digit1",
    shortcutKey: `1`,
  },
  COURSE_2: {
    code: "Digit2",
    shortcutKey: `2`,
  },
  COURSE_3: {
    code: "Digit3",
    shortcutKey: `3`,
  },
  COURSE_4: {
    code: "Digit4",
    shortcutKey: `4`,
  },
  COURSE_5: {
    code: "Digit5",
    shortcutKey: `5`,
  },
  COURSE_6: {
    code: "Digit6",
    shortcutKey: `6`,
  },
  COURSE_7: {
    code: "Digit7",
    shortcutKey: `7`,
  },
  COURSE_8: {
    code: "Digit8",
    shortcutKey: `8`,
  },
  COURSE_9: {
    code: "Digit9",
    shortcutKey: `9`,
  },
  LEARNING_COURSE_1: {
    shortcutKey: "C1",
    combination: ["KeyC", "Digit1"],
  },
  LEARNING_COURSE_2: {
    shortcutKey: "C2",
    combination: ["KeyC", "Digit2"],
  },
  LEARNING_COURSE_3: {
    shortcutKey: "C3",
    combination: ["KeyC", "Digit3"],
  },
  LEARNING_COURSE_4: {
    shortcutKey: "C4",
    combination: ["KeyC", "Digit4"],
  },
  LEARNING_COURSE_5: {
    shortcutKey: "C5",
    combination: ["KeyC", "Digit5"],
  },
  LEARNING_COURSE_6: {
    shortcutKey: "C6",
    combination: ["KeyC", "Digit6"],
  },
  LEARNING_COURSE_7: {
    shortcutKey: "C7",
    combination: ["KeyC", "Digit7"],
  },
  LEARNING_COURSE_8: {
    shortcutKey: "C8",
    combination: ["KeyC", "Digit8"],
  },
  LEARNING_COURSE_9: {
    shortcutKey: "C9",
    combination: ["KeyC", "Digit9"],
  },
  PROJECT_1: {
    code: "Digit1",
    shortcutKey: `1`,
    shiftKey: true,
  },
  PROJECT_2: {
    code: "Digit2",
    shortcutKey: `2`,
    shiftKey: true,
  },
  PROJECT_3: {
    code: "Digit3",
    shortcutKey: `3`,
    shiftKey: true,
  },
  PROJECT_4: {
    code: "Digit4",
    shortcutKey: `4`,
    shiftKey: true,
  },
  PROJECT_5: {
    code: "Digit5",
    shortcutKey: `5`,
    shiftKey: true,
  },
  PROJECT_6: {
    code: "Digit6",
    shortcutKey: `6`,
    shiftKey: true,
  },
  PROJECT_7: {
    code: "Digit7",
    shortcutKey: `7`,
    shiftKey: true,
  },
  PROJECT_8: {
    code: "Digit8",
    shortcutKey: `8`,
    shiftKey: true,
  },
  PROJECT_9: {
    code: "Digit9",
    shortcutKey: `9`,
    shiftKey: true,
  },
};

const _checkIsAIEnabledInModule = moduleKey => {
  switch (moduleKey) {
    case AI_MODULES_FOR_MARKETING.PORTFOLIO:
      return ACLStore.can("FeatureFlag:PortfolioAIWeb");
    case AI_MODULES_FOR_MARKETING.LESSON_PLANNING:
      return ACLStore.can("FeatureFlag:AILessonPlanning");
    case AI_MODULES_FOR_MARKETING.ANNOUNCEMENTS:
      return getIsAIEnabledInAnnouncementModule();
    case AI_MODULES_FOR_MARKETING.PROGRESS_REPORTS:
      return ACLStore.can("Common:ChatGPTPoweredTextFeatures");
    default:
      return false;
  }
};

export const isAIModuleMarketingEnabled = moduleKey => {
  return (dispatch, getState) => {
    const state = getState();

    if (
      !_.has(AI_MODULES_FOR_MARKETING, moduleKey) ||
      _checkIsAIEnabledInModule(moduleKey)
    ) {
      return false;
    }

    const marketingParams = getDefaultAccountManagerDetailsFromCache();

    // We use derrived flag to check if AI is enabled for the overall org or not
    const isAnyAIModuleEnabled = ACLStore.can("Common:ToddleAIEnabled");

    const isUltimateSchool = !_.isEmpty(marketingParams)
      ? _.get(marketingParams, "isUltimateOrg", true)
      : true;

    const isPaidSchool = _.get(
      getOrganizationDetailsFromCache(getOrganizationId()),
      "isPaid",
      false
    );

    const excludedModulesList = getSettingValue({
      name: "ExcludedAIModuleForProductMarketing",
      readFromUserAndOrgLevel: true,
      organizationId: getOrganizationId(state),
      userId: getUserId(state),
    });

    const isModuleExcluded = _.includes(excludedModulesList, moduleKey);

    const shouldShowMarketingModal = ACLStore.can(
      "FeatureFlag:AIProductMarketing"
    );

    return (
      !isUltimateSchool &&
      !isAnyAIModuleEnabled &&
      !isModuleExcluded &&
      isPaidSchool &&
      shouldShowMarketingModal
    );
  };
};

export const isAITutorMarketingEnabled = data => {
  const { checkUserPreference = false, userId } = data || {};

  if (ACLStore.can(ENABLE_AI_TUTOR)) {
    return false;
  }

  const marketingParams = getDefaultAccountManagerDetailsFromCache();
  const isUltimateSchool = !_.isEmpty(marketingParams)
    ? _.get(marketingParams, "isUltimateOrg", true)
    : true;
  const isPaidSchool = _.get(
    getOrganizationDetailsFromCache(getOrganizationId()),
    "isPaid",
    false
  );

  const isTutorMarketingEnabled =
    ACLStore.can("FeatureFlag:AITutorMarketing") &&
    !ACLStore.can("Common:AITutorEnabled");

  if (checkUserPreference) {
    const isUserClosedBanner = getSettingValue({
      name: "isTutorMarketingBannerClosed",
      readFromUserAndOrgLevel: true,
      userId,
    });
    return !isUltimateSchool && !isUserClosedBanner && isTutorMarketingEnabled;
  }

  return !isUltimateSchool && isPaidSchool && isTutorMarketingEnabled;
};

export const isMarketingModalEnabled = () => {
  return (
    (ACLStore.can("FeatureFlag:AIProductMarketing") &&
      !ACLStore.can("Common:ToddleAIEnabled")) ||
    (ACLStore.can("FeatureFlag:AITutorMarketing") &&
      !ACLStore.can("Common:AITutorEnabled"))
  );
};

export const isHomepageBannerMarketingEnabled = ({ userId }) => {
  const marketingParams = getDefaultAccountManagerDetailsFromCache();
  const isUltimateSchool = !_.isEmpty(marketingParams)
    ? _.get(marketingParams, "isUltimateOrg", true)
    : true;

  const isPaidSchool = _.get(
    getOrganizationDetailsFromCache(getOrganizationId()),
    "isPaid",
    false
  );

  const isUserClosedBanner = getSettingValue({
    name: "isHomepageAIMarketingBannerClosed",
    readFromUserAndOrgLevel: true,
    userId,
  });

  return (
    !isUltimateSchool &&
    !isUserClosedBanner &&
    isPaidSchool &&
    ACLStore.can("FeatureFlag:EnableHomepageAIMarketingBanner")
  );
};

export const checkIfPermissionIsEnabledInAnyCurriculum = ({
  permission,
  curriculumProgramIds,
}) => {
  return _.some(curriculumProgramIds, curriculumProgramId => {
    return ACLStorage.getModuleSettingsValueByContext(permission, [
      { entityType: "CURRICULUM_PROGRAM", entityId: curriculumProgramId },
    ]);
  });
};

export const getVariablesForProgramWideConfigurations = ({
  curriculumPrograms,
}) => {
  const contexts = [];

  const programsCount = _.size(curriculumPrograms);

  for (let i = 0; i < programsCount; i++) {
    const { id } = curriculumPrograms[i];

    const context = [
      {
        entityId: id,
        entityType: "CURRICULUM_PROGRAM",
      },
    ];

    contexts.push(context);
  }

  return {
    filters: {
      module: "PROGRAMME_WIDE_CONFIGURATION",
      appType: ["ADMIN_WEB"],
      contexts,
    },
  };
};

export const getIsAdminPortalVisible = ({
  isOrganizationFree,
  userCurriculumPrograms,
}) => {
  const curriculumProgramIds = _.map(userCurriculumPrograms, "id");
  return (
    (ACLStorage.getModuleSettingsValueByContext(
      ADMIN_PORTAL_ACCESS_PERMISSION,
      []
    ) ||
      checkIfPermissionIsEnabledInAnyCurriculum({
        permission: PROGRAMME_WIDE_CONFIGURATIONS_ACCESS_PERMISSION,
        curriculumProgramIds,
      })) &&
    !isOrganizationFree &&
    !(
      ACLStore.can("FeatureFlag:AdminHome") &&
      ACLStore.can("FeatureFlag:AdminSettings")
    )
  );
};

export const getProjectGroupContexts = ({
  projectGroupCategoryId,
  curriculumProgramId,
}) => {
  return [
    {
      entityId: projectGroupCategoryId,
      entityType: "PROJECT",
    },
    {
      entityId: curriculumProgramId,
      entityType: "CURRICULUM_PROGRAM",
    },
  ];
};

export const getIsCombineCurriculumHomePageEnabled = () => {
  return ACLStore.can(COMBINE_CURRICULUM_HOME_PAGE_PERMISSION);
};

export const getIsStaticWidgetisedFeatureFlagEnabled = () => {
  return ACLStore.can(STATIC_WIDGETISED_SCHOOL_HOMEPAGE_V0);
};

export const getIsWidgetisedHomepagePreferred = () => {
  const value = getSettingValue({
    name: "UseWidgetisedHomepage",
    readFromUserAndOrgLevel: true,
    userId: getUserId(),
  });
  return _.isBoolean(value) ? value : true;
};

export const getIsStaticWidgetisedHomepageEnabled = () => {
  return (
    getIsStaticWidgetisedFeatureFlagEnabled() &&
    getIsWidgetisedHomepagePreferred()
  );
};

export const getIsWidgetisedHomepageEnabled = () => {
  return ACLStore.can(WIDGETISED_SCHOOL_HOMEPAGE);
};

export const generateContextsForHomePageModules = (state, moduleKey) => {
  const userCurriculumPrograms = moduleKey
    ? _.get(
        getProgramListForModule(moduleKey),
        "enabledCurriculumProgramIds",
        []
      )
    : _.map(getUserCurriculumPrograms(), "id");
  let curriculumProgramIds = [];
  if (getIsCombineCurriculumHomePageEnabled()) {
    curriculumProgramIds = userCurriculumPrograms;
  } else {
    curriculumProgramIds = [getSelectedCurriculumId(state)];
  }

  return _.map(curriculumProgramIds, curriculumProgramId => {
    const contextForCurriculum = [
      {
        entityId: curriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ];

    return contextForCurriculum;
  });
};

export const getPermissionEnabledInAnyCurriculum = ({
  permission,
  curriculumProgramIds,
}) => {
  return (
    getPermissionEnabledCurriculumIds({
      permission,
      curriculumProgramIds,
    }).length > 0
  );
};

export const getModuleEnabledInAnyCurriculum = ({
  module,
  curriculumProgramIds,
}) => {
  return (
    getModuleEnabledCurriculumIds({
      module,
      curriculumProgramIds,
    }).length > 0
  );
};

export const getPermissionEnabledCurriculumIds = ({
  permission,
  curriculumProgramIds,
}) => {
  if (!permission || !curriculumProgramIds?.length) {
    return [];
  }

  return curriculumProgramIds.filter(curriculumProgramId =>
    ACLStorage.getPermissionValueByContext(permission, [
      { entityType: "CURRICULUM_PROGRAM", entityId: curriculumProgramId },
    ])
  );
};

export const getModuleEnabledCurriculumIds = ({
  module,
  curriculumProgramIds,
}) => {
  if (!module || !curriculumProgramIds?.length) {
    return [];
  }

  return curriculumProgramIds.filter(curriculumProgramId =>
    ACLStorage.getModuleSettingsValueByContext(module, [
      { entityType: "CURRICULUM_PROGRAM", entityId: curriculumProgramId },
    ])
  );
};

export const getFilteredUserCurriculumProgramIds = ({
  permission,
  module,
  curriculumProgramIds,
}) => {
  if (!curriculumProgramIds.length) {
    return [];
  }

  if (permission) {
    return getPermissionEnabledCurriculumIds({
      permission,
      curriculumProgramIds,
    });
  }

  if (module) {
    return getModuleEnabledCurriculumIds({
      module,
      curriculumProgramIds,
    });
  }

  return curriculumProgramIds;
};

export const getDataGroupedByCurriculum = ({
  data = [],
  valueField = "id",
  labelField = "name",
  generateSortedData = true,
}) => {
  const groupedByCurriculum = _.groupBy(data, item =>
    _.get(item, "curriculumProgram.id")
  );

  if (_.size(groupedByCurriculum) <= 1) {
    return _.map(data, item => {
      return {
        label: item[labelField],
        value: item[valueField],
        disabled: _.get(item, "disabled", false),
        disabledTooltip: _.get(item, "disabledTooltip", ""),
      };
    });
  }

  const formattedData = _.reduce(
    groupedByCurriculum,
    (result, groupedValues) => {
      const firstItem = _.first(groupedValues);
      const acronym = _.get(firstItem, "curriculumProgram.acronym");
      const curriculumProgramType = _.get(firstItem, "curriculumProgram.type");
      const curriculumProgramId = _.get(firstItem, "curriculumProgram.id");

      const options = groupedValues.map(item => ({
        value: item[valueField],
        label: item[labelField],
        disabled: _.get(item, "disabled", false),
        disabledTooltip: _.get(item, "disabledTooltip", ""),
      }));

      result.push({
        id: curriculumProgramId,
        label: acronym,
        options,
        curriculumProgramType,
        disabled: _.every(options, item => _.get(item, "disabled", false)),
      });

      return result;
    },
    []
  );

  if (!generateSortedData) {
    return formattedData;
  }

  const sortedData = _.orderBy(
    formattedData,
    [obj => CURRICULUM_TYPE_ORDER_MAPPING[obj.curriculumProgramType]],
    "asc"
  );
  return sortedData;
};

/**
 * Retrieves timezone data from cache for the given organization
 * @param {Object} params - The parameters object
 * @param {string} params.organizationId - The organization ID
 * @param {string} params.currentTimezoneConfig - The current timezone configuration
 * @param {boolean} params.isTimezoneEnabled - Whether timezone feature is enabled
 * @returns {Object} Object containing organizationTimezone and platformTimezone
 */
export const getTimezoneDataFromCache = ({
  organizationId,
  currentTimezoneConfig,
  isTimezoneEnabled,
}) => {
  if (!isTimezoneEnabled || !organizationId) {
    return {
      organizationTimezone: null,
      platformTimezone: null,
    };
  }

  const queryData = getOrganizationGlobalConstantsFromCache({
    organizationId,
    filter: {
      names: ["TIMEZONE"],
    },
  });

  const timeZone =
    _.find(
      _.get(queryData, "node.globalConstants", []),
      ({ name }) => name === "TIMEZONE"
    ) ?? {};

  const organizationTimezone = getTimezoneByValue(
    _.get(timeZone, "value", getGlobalTimezone())
  ) || { value: getGlobalTimezone() };

  let tempCurrentTimezoneValue;
  let mode = "CUSTOM";

  switch (currentTimezoneConfig) {
    case "ORG":
    case "UNDEFINED":
      tempCurrentTimezoneValue = organizationTimezone.value;
      mode = currentTimezoneConfig;
      break;
    default:
      tempCurrentTimezoneValue = currentTimezoneConfig;
      break;
  }

  const platformTimezone = {
    ...getTimezoneByValue(tempCurrentTimezoneValue),
    mode,
  };

  return {
    organizationTimezone,
    platformTimezone,
  };
};

export const getCurriculumProgramIdsFromCache = ({
  userId,
  userEntityType,
  childID,
}) => {
  const userData = getPlatformUserCurriculumProgramsFromCache({
    id: userId,
    type: userEntityType,
  });

  const userType = _.get(userData, "type", "");
  let organizationData;

  if (userType === PARENT) {
    const children = _.get(userData, "children", []);
    const activeChildData = _.find(children, { id: childID });
    const childData = !_.isEmpty(activeChildData)
      ? activeChildData
      : _.head(children);
    organizationData = _.get(childData, "organization", {});
  } else {
    organizationData = _.get(userData, "organization", {});
  }

  const curriculumPrograms = _.get(organizationData, "curriculumPrograms", []);
  return _.map(curriculumPrograms, "id");
};
